<template>
  <header>
    <!-- Main Nav -->
    <div 
      class="top-0 left-0 w-full z-50 transition-all duration-300"
      :class="isScrolled ? 'bg-white shadow-md fixed' : 'bg-transparent absolute'"
    >
      <div class="md:px-12 max-w-screen-2xl mx-auto flex justify-between items-center py-4">
        <!-- Logo -->
        <div class="px-4 lg:px-2 text-3xl" :class="isScrolled ? 'text-black' : 'text-white'">
          <router-link to="/">
            <img 
              :src="isScrolled ? require('../assets/images/BM_Black.svg') : require('../assets/images/BM_White White.svg')" 
              alt="Barka U Mshelia" 
              class="h-8 md:h-12" 
            />
          </router-link>
        </div>

        <!-- Desktop Nav -->
        <nav class="hidden lg:flex items-center space-x-6 relative z-50">
          <router-link 
            to="/" 
            class="hover:text-blue transition-all duration-300" 
            :class="isScrolled ? 'text-black' : 'text-white'"
            exact-active-class="active-link"
          >
            Home
          </router-link>
          
          <!-- About Dropdown for Desktop -->
          <div class="relative group cursor-pointer" :class="{ 'active-link': isAboutActive }">
            <div 
              class="px-5 inline-flex items-center transition-all duration-300 hover:text-blue"
              :class="isScrolled ? 'text-black' : 'text-white'"
            >
              About
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div id="dropdownHover" class="hidden group-hover:block absolute left-0 z-50 bg-black bg-opacity-70 divide-y divide-black shadow-lg w-44">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Biography</router-link>
                </li>
                <!-- <li>
                  <router-link to="/mshel-club" class="block px-4 py-4 hover:bg-[#202020]">Join the Mshel Club</router-link>
                </li> -->
                <li>
                  <router-link to="/mshel-group" class="block px-4 py-4 hover:bg-[#202020]">About Mshel Group</router-link>
                </li>
                <li>
                  <router-link to="/gallery" class="block px-4 py-4 hover:bg-[#202020]">Gallery</router-link>
                </li>
              </ul>
            </div>
          </div>

          <router-link 
            to="/impact" 
            class="hover:text-blue transition-all duration-300" 
            :class="isScrolled ? 'text-black' : 'text-white'"
            exact-active-class="active-link"
          >
            Barka's Impact
          </router-link>

          <!-- Mentorship Dropdown for Desktop -->
          <div class="relative group cursor-pointer" :class="{ 'active-link': isMentorshipActive }">
            <div 
              class="px-5 inline-flex items-center transition-all duration-300 hover:text-blue"
              :class="isScrolled ? 'text-black' : 'text-white'"
            >
              Masterclass
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div id="dropdownHover" class="hidden group-hover:block absolute left-0 z-50 bg-black bg-opacity-70 divide-y divide-black shadow-lg w-52">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/bum-masterclass" class="block px-4 py-4 hover:bg-[#202020]">BUM Masterclass</router-link>
                </li>
                <li>
                  <router-link to="/mrem-masterclass" class="block px-4 py-4 hover:bg-[#202020]">MREM Masterclass</router-link>
                </li>
              </ul>
            </div>
          </div>
          
          <router-link 
            to="/resources" 
            class="hover:text-blue transition-all duration-300" 
            :class="isScrolled ? 'text-black' : 'text-white'"
            exact-active-class="active-link"
          >
            Resources
          </router-link>
          
          <router-link 
            to="/contact" 
            class="hover:text-blue transition-all duration-300" 
            :class="isScrolled ? 'text-black' : 'text-white'"
            exact-active-class="active-link"
          >
            Contact
          </router-link>

          <!-- <router-link to="/mshel-club" class="bg-gradient text-white rounded px-4 py-2 transition-transform hover:scale-110 focus:outline-none">
              Mshel Club
          </router-link> -->
        </nav>

        <!-- Mobile Menu Button -->
        <div class="lg:hidden">
          <button @click.prevent="toggleMenu" class="focus:outline-none" :class="isScrolled ? 'text-black' : 'text-white'">
            <i v-if="!isMenuOpen" class="fa-solid fa-bars w-10 h-10"></i>
            <i v-else class="fa-solid fa-xmark w-10 h-10"></i>
          </button>
        </div>
      </div>

      <!-- Mobile Nav -->
      <div v-if="isMenuOpen" class="bg-black lg:hidden">
        <nav class="flex flex-col space-y-4 py-4 px-2 text-white">
          <router-link to="/" class="hover:text-blue transition-all duration-300">Home</router-link>
          <!-- About Dropdown for Mobile -->
          <div class="relative">
            <div @click="toggleDropdownAbout" class="text-white hover:text-blue flex items-center transition-all duration-300">
              About
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div v-if="isDropdownOpenAbout" class="bg-black bg-opacity-70 divide-y divide-black shadow-lg w-44">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/about" class="block px-4 py-4 hover:bg-[#202020]">Biography</router-link>
                </li>
                <!-- <li>
                  <router-link to="/mshel-club" class="block px-4 py-4 hover:bg-[#202020]">Join the Mshel Club</router-link>
                </li> -->
                <li>
                  <router-link to="/mshel-group" class="block px-4 py-4 hover:bg-[#202020]">About Mshel Group</router-link>
                </li>
              </ul>
            </div>
          </div>

          <router-link to="/impact" class="text-white hover:text-blue transition-all duration-300">Barka's Impact</router-link>
          
          <!-- Mentorship Dropdown for Mobile -->
          <div class="relative">
            <div @click="toggleDropdownLeader" class="text-white hover:text-blue flex items-center transition-all duration-300">
              Masterclass
              <svg class="w-2.5 h-2.5 ms-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
              </svg>
            </div>
            <div v-if="isDropdownOpenLeader" class="bg-black bg-opacity-70 divide-y divide-black shadow-lg w-52">
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link to="/bum-masterclass" class="block px-4 py-4 hover:bg-[#202020]">BUM Masterclass</router-link>
                </li>
                <li>
                  <router-link to="/mrem-masterclass" class="block px-4 py-4 hover:bg-[#202020]">MREM Masterclass</router-link>
                </li>
              </ul>
            </div>
          </div>
          
          <router-link to="/resources" class="text-white hover:text-blue transition-all duration-300">Resources</router-link>
          <router-link to="/contact" class="hover:text-blue transition-all duration-300">Contact</router-link>

          <!-- <router-link to="/mshel-club" class="bg-gradient text-white px-4 py-2 rounded hover:bg-[#d3d3d3] transition-transform hover:scale-110 focus:outline-none">
              Mshel Club
          </router-link> -->
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { useRoute } from "vue-router";
export default {
  data() {
    return {
      isMenuOpen: false,
      isDropdownOpenAbout: false,
      isDropdownOpenLeader: false,
      isScrolled: false,
    };
  },
  computed: {
    route() {
      return useRoute();
    },
    isAboutActive() {
      return ["/about", "/mshel-group"].includes(
        this.route.path
      );
    },
    isMentorshipActive() {
      return ["/bum-masterclass", "/mrem-masterclass"].includes(this.route.path);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleDropdownAbout() {
      this.isDropdownOpenAbout = !this.isDropdownOpenAbout;
    },
    toggleDropdownLeader() {
      this.isDropdownOpenLeader = !this.isDropdownOpenLeader;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
  },
};
</script>

<style scoped>
#dropdownHover {
  z-index: 1000;
}

.group:hover #dropdownHover {
  display: block;
}

.active-link {
  font-weight: 600;
  position: relative;
}

.active-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  top: 28px;
  width: 100%;
  height: 2px;
  background-color: #374bc6;
  border-radius: 10px;
}

.active-link .inline-flex::after {
  bottom: -6px;
}

.active-links {
  color: #e89e1c;
  font-weight: 600;
  position: relative;
}

.active-links::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #374bc6;
  border-radius: 10px;
}

.active-links .inline-flex::after {
  bottom: -6px;
}

@media (max-width: 1024px) {
  #dropdownHover {
    display: none;
  }
}
</style>